import { Box, Chip, TextField } from "@mui/material"
import { useState } from "react";

export const KeywordsCustom = ({ 
    label = '',
    variant = 'filled',
    maxItems,
    parentCallback,
}) => {

    const [tags, setTags] = useState([]);
    const [newTagValue, setNewTagValue] = useState('');


    const onNewTag = () => {
        const newTag = newTagValue.trim().toLowerCase();
        console.log({newTag});
        setNewTagValue('');
        const currentTags = JSON.parse( JSON.stringify(tags) );

        if ( currentTags.includes(newTag) || newTag === '' ) {
            return;
        }

        if ( maxItems > 0 && currentTags.length >= maxItems) {
            return; 
        }

        currentTags.push(newTag);
        setTags(currentTags);
        parentCallback(currentTags);
    }

    const onDeleteTag = (tag) => {
        const updatedTags = tags.filter( t => t !== tag );
        setTags(updatedTags);
        parentCallback(updatedTags);
    }

    return (
        <Box width={ '100%' }>
            <TextField 
                label={ label }
                variant={ variant }
                fullWidth 
                size='small'
                sx={{ mb: 1 }}
                helperText={ 
                    `Barra espaciadora para agregar ${ maxItems ? `(máximo ${ maxItems })` : ''} / Press spacebar to add ${ maxItems ? `(max. ${ maxItems })` : ''}` 
                }
                value={ newTagValue }
                onChange={ ({ target }) => setNewTagValue(target.value) }
                onKeyUp={ ({ code }) => code === 'Space' ? onNewTag() : undefined }
            />

            <Box 
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    listStyle: 'none',
                    p: 0.5,
                    m: 0,
                    border: '1px solid lightgray',
                    borderRadius: '20px',
                    minHeight: '40px'
                }}
                component='ul'
            >
                {
                    tags.map((tag) => {

                        return (
                            <Chip
                                key={tag}
                                label={tag}
                                onDelete={ () => onDeleteTag(tag) }
                                color='primary'
                                size='small'
                                sx={{ m: 0.5 }}
                            />
                        );
                    }
                )}
            </Box>
        </Box>
        
    )
}
